import { VERIFICATION_TYPES } from "../../../enums/Enums";

export class VerificationCodeEntity {
    userIdentityId;
    contactInfo;
    verificationType;
    code;
    isUpdatePhone;

    constructor(userIdentityId = '', contactInfo = '', verificationType = VERIFICATION_TYPES.MOBILE, code = '', isUpdatePhone = false) {
        this.userIdentityId = userIdentityId;
        this.contactInfo = contactInfo;
        this.verificationType = verificationType;
        this.code = code;
        this.isUpdatePhone = isUpdatePhone;
    };
};